import { EditOutlined } from '@ant-design/icons';
import { Steps } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import Wrap from './styles';

type Props = {
  currentStep: number;
  nextStep: () => void;
};
const HeaderMachineRegister: FC<Props> = ({ nextStep, currentStep }) => {
  const { Step } = Steps;
  const [title, setTitle] = useState<string>('1. リース内容登録');
  const [current, setCurrent] = useState<number>(0);

  useEffect(() => {
    setCurrent(currentStep);
    switch (currentStep) {
      case 0:
        setTitle('1. リース内容登録');
        break;
      case 1:
        setTitle('2. 登録内容の確認');
        break;
      case 2:
        setTitle('3. 登録完了');
        break;
    }
  }, [currentStep]);

  return (
    <Wrap>
      <div className="header1">
        <div>
          <EditOutlined className="icon1" />
          <p className="extraLargeFont inline">リース契約登録</p>
        </div>
        <div>
          <Steps size="small" type="navigation" current={current} className="site-navigation-steps">
            <Step title="リース内容入力" />
            <Step title="登録内容の確認" />
            <Step className="last" title="登録完了" />
          </Steps>
        </div>
      </div>
      <div className="header2 extraLargeFont">{title}</div>
    </Wrap>
  );
};

export default HeaderMachineRegister;
